import { Component, ViewChild, ElementRef, EventEmitter, Output, ContentChild } from '@angular/core';
import { EnvService } from 'src/app/env.service';
import { SLLayer } from 'src/app/model/sl-layer';
import { ViewStackComponent } from '../view-stack/view-stack.component';

export interface PopupChanges {
	popup: string;
	tool: string;
}

@Component({
	selector: 'app-results-popup-editor',
	templateUrl: './results-popup-editor.component.html',
	styleUrls: ['./results-popup-editor.component.scss']
})
export class ResultsPopupEditorComponent {

	constructor(private env: EnvService) {
		this.textPositions = this.textPositions;
	}
	@ViewChild('popupTextArea') popupTextArea: ElementRef;
	public popupTip = 'hi';
	public popupTipSelection = { start: -1, end: -1 };
	public editorConfig: any = {
		height: 200,
		autoGrow_maxHeight: 200,
		resize_maxHeight: 200,
		resize_enabled: false,
		toolbarGroups: [
			{ name: 'document', groups: ['mode', 'document', 'doctools'] },
			{ name: 'clipboard', groups: ['clipboard', 'undo'] },
			{ name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
			{ name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
			{ name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'paragraph'] },
			{ name: 'links', groups: ['links'] },
			{ name: 'insert', groups: ['insert'] },
			{ name: 'styles', groups: ['styles'] },
			{ name: 'colors', groups: ['colors'] },
			{ name: 'tools', groups: ['tools'] },
			{ name: 'others', groups: ['others'] },
			{ name: 'about', groups: ['about'] }
		],
		removeButtons: 'Save,NewPage,Preview,Print,Templates,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,BidiLtr,Flash,Smiley,PageBreak,Maximize,M'
	};
	public iconPath = this.env.baseHRef + 'assets/images/iconfinder/iconfinder_at-sign_2561335.png';
	public hasAttrs = false;
	public ready = false;
	public attributes = [];
	public viewList = ['Popup Text', 'Hover Text'];
	public viewListReady = true;
	public viewName = '';
	public viewStack: ViewStackComponent;
	public tooltipText = '';
	private layer: SLLayer;
	private textPositions: any = {};
	private editorInstance: any = null;

	@ViewChild('attrInput', { static: true }) attrInput: ElementRef;
	@ContentChild('ckEditor', { static: true }) ckEditor: any;
	@ContentChild('hoverTipInput', { static: true }) hoverTipInput: ElementRef;

	@Output() popupTipChange = new EventEmitter<PopupChanges>();


	SetLayer(layer: SLLayer) {

		this.ready = false;
		this.layer = layer;
		this.attributes = this.layer.layerAttributes;
		this.hasAttrs = true;
		this.popupTip = this.layer.richTooltip;
		window.requestAnimationFrame(() => {
			this.ready = true;
			if (!!this.ckEditor) {
				(this.ckEditor.ready as EventEmitter<any>).subscribe(() => {
					this.attrInput.nativeElement.style.maxHeight = 'calc(200px + 9em)';
				});
			}
			this.tooltipText = this.layer.tooltip;
		});
	}
	Ready() {
		if (!!this.ckEditor) {
			window.requestAnimationFrame(() => {
				this.ready = true;
				if (!!this.ckEditor) {
					(this.ckEditor.ready as EventEmitter<any>).subscribe(() => {
						this.attrInput.nativeElement.style.maxHeight = 'calc(200px + 9em)';
					});
				}
			});
		} else {
			window.requestAnimationFrame(() => { this.Ready(); });
		}
	}
	ViewsReady(viewStack: ViewStackComponent) {
		this.viewStack = viewStack;
		this.SetView(this.viewStack.selectedView);
	}
	SetView(viewName: string) {
		this.viewName = viewName;
		this.viewStack.SetView(this.viewName);
	}

	Hide() {
		$(this.attrInput.nativeElement).toggleClass('invis', true);
	}
	Show() {
		$(this.attrInput.nativeElement).toggleClass('invis', false);
	}
	GetAttribute(e: any) {
		this.editorInstance = e;
		this.Show();
	}
	AddAttr(name: string) {
		switch (this.viewName) {
			case 'Popup Text':

				this.editorInstance.insertText('[' + name + ']');
				break;
			case 'Hover Text':
				let hoverText = this.tooltipText;

				const fieldEntry = '[' + name + ']';
				if (this.popupTipSelection.start !== -1) {
					if (this.popupTipSelection.end !== -1) {
						const start = hoverText.substr(0, this.popupTipSelection.start);
						const end = hoverText.substr(this.popupTipSelection.end);
						this.tooltipText = start + fieldEntry + end;
						this.Hide();
						return;
					}
				} else {
          hoverText += fieldEntry;
        }
				this.tooltipText = hoverText;
				this.Hide();
		}

	}
	Update() {

		this.popupTipChange.emit({ popup: this.popupTip, tool: this.tooltipText });
	}
	HandleSelect(target?) {
		this.popupTipSelection.start = this.popupTextArea.nativeElement.selectionStart;
		this.popupTipSelection.end = this.popupTextArea.nativeElement.selectionEnd;

	}


}
